import { Price } from './price.model';
import { AttributeOption } from './attribute-option.model';
import { AttributeRelationDependencyType } from '../../../../shared/enums/attribute-relation-dependency-type.enum';
import { DependencyComparisonType } from '@deltager/organizers/admin/shared/enums/dependency-comparison-type.enum';

export class AttributeRelation {
  attributeId?: number;
  dependentAttributeId?: number;
  dependentAttributeDetailsId?: number;
  dependencyType?: AttributeRelationDependencyType;
  currentDependencyList?: AttributeOption[];
  relatedList?: Price[] | AttributeOption[];
  uiId?: number;
  comparisonValue?: string;
  comparisonType: DependencyComparisonType = DependencyComparisonType.Equals;

  public showValueComparisonFields(): boolean {
    return this.dependentAttributeId === -2;
  }

  static buildAttributeRelation(
    uiId: number,
    attributeId?: number,
    comparisonType?: DependencyComparisonType,
    comparisonValue?: string,
  ) {
    const relation = new AttributeRelation();
    relation.attributeId = attributeId;
    relation.dependentAttributeId = undefined;
    relation.dependentAttributeDetailsId = undefined;
    relation.uiId = uiId;
    relation.comparisonType = comparisonType ?? DependencyComparisonType.Equals;
    relation.comparisonValue = comparisonValue;
    return relation;
  }
}
